import type { StatData } from "../types/stats";
import { normalizeItemName } from "./itemAliases";
import { getAmount } from "./animation";

/**
 * 選択された都市リストを解決する。
 * 空配列なら全都市を返す。
 */
export function resolveCities(
  selected: string[],
  allCities: string[],
): string[] {
  return selected.length === 0 ? allCities : selected;
}

/**
 * 品目名が利用可能なアイテム一覧に存在するか確認する。
 * エイリアス正規化後に検索する。
 */
export function validateItem(
  item: string,
  availableItems: string[],
): boolean {
  const normalized = normalizeItemName(item);
  return availableItems.some(
    (i) => i === normalized || i === item,
  );
}

/**
 * 指定年・品目で X/Y 両方のデータが存在する都市のみを返す。
 * アニメーション中にデータ欠損都市を除外するために使用。
 */
export function filterAvailableCities(
  data: StatData,
  year: number,
  itemX: string,
  itemY: string,
  cities: string[],
): string[] {
  return cities.filter((city) => {
    const x = getAmount(data, year, city, itemX);
    const y = getAmount(data, year, city, itemY);
    return x !== null && y !== null;
  });
}
